export function login() {
  if ($('#LoginView').length && !$('#LoginView .logo').length) {
    const logoUrl = $('#imgLogo').attr('src');
    $('#LoginText').prepend('<img src="' + logoUrl + '" class="login-logo">');
  }
}